module.exports = __webpack_public_path__ + "static/img/bm.e87e6011.png";